export const HIDE_HEADER_CLASS = 'hide-hedepy-header' as const
